export default __webpack_public_path__ + "a20323bf3e27966237be67e6836d0936.svg";